<template>
  <div v-bind:class="{ 'version-spacing': !isLoggedIn }">
    <PageHeader title="Competitions" :refresh="true"></PageHeader>
    <v-container class="page-bottom pa-0">
      <v-row>
        <v-col>
          <h3 v-if="competitions && competitions.length === 0">No active competitions</h3>
          <v-card
            outlined
            v-for="competition in competitions" :key="competition.id"
            class="mb-4"
          >
            <v-container>
              <v-row>
                <v-col cols="8">
                  <v-icon color="#757575">mdi-calendar-blank-outline</v-icon> <span class="competition-date-time">{{competition.matchStartDate | moment("DD MMM YY")}}</span>
                  <v-icon color="#757575">mdi-clock-outline</v-icon> <span class="competition-date-time">{{competition.matchStartDate | moment("HH:mm")}}</span>
                </v-col>
                <v-col class="text-right" cols="4">
                  {{competition.sportName}}
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="5" align="center">
                  <CompetitionTeam 
                  :name="competition.ownTeamName"
                  :shield="competition.ownClubShield"
                  :ball="competition.ownClubBallColour"
                  ></CompetitionTeam>
                </v-col>
                <v-col cols="2" align="center">
                  <img :src="require('@/assets/vs.png')" class="VS" />
                </v-col>
                <v-col cols="5" align="center">
                  <CompetitionTeam 
                  :name="competition.opponentTeamName"
                  :shield="competition.opponentClubShield"
                  :ball="competition.opponentClubBallColour"
                  ></CompetitionTeam>
                </v-col>
              </v-row>
              <v-row v-if="competition.sponsorId">
                <v-col>
                  <img :src="competition.sponsorLogo" :alt="competition.sponsorName" class="sponsor-logo">
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col>
                  <v-btn outlined large block 
                  @click="enterFor(competition.id)"
                  color="fanhiveHoney"
                  style="color: #ffffff !important;border: 1px solid #ffb300;"
                  id="click-enter-for"
                  >Enter for {{competition.ownTeamName.substring(0, 18)}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="dialog"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Competition Particulars</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedCompetition" style="color:#ffffff;" class="honeyBold">
          <p style="font-weight:bold;">
            WIN <span v-if="selectedCompetition.sponsorCommitment"><b>£{{selectedCompetition.fanShareOfSponsorship}}</b> SPONSORED CASH PLUS </span>CASH FROM THE WINNERS POOL <br> CURRENT POOL AMOUNT <b>£{{selectedCompetition.fanShareOfTicketIncome}}</b></p>
          <p><b>£{{selectedCompetition.entryCredits}} per entry</b>, {{selectedCompetition.maxEntries === null ? "Unlimited" : selectedCompetition.maxEntries}} entries available</p>
          <p><b>Answer questions:</b> Answer {{selectedCompetition.totalQuestions}} {{selectedCompetition.sportName}} related timed questions</p>
          <p><b>Select player of the match:</b> Select the {{selectedCompetition.ownTeamName}} Fans Player of the Match after the match</p>
          <p>and</p>
          <p><b>Rate players:</b> Rate the {{selectedCompetition.ownTeamName}} Players after the match (optional)</p>
          <p>Competition ends on {{selectedCompetition.endDate | moment("dddd, DD MMMM YYYY")}} at {{selectedCompetition.endDate | moment("HH:mm")}}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="fanhiveHoney"
            @click="buyEntry"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            Buy Entry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInsufficientFunds"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Insufficient Funds</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedCompetition" style="color:#ffffff;" class="honeyBold">
          <p>
            This competition requires <b>{{selectedCompetition.entryCredits}}</b> <b>{{selectedCompetition.entryCredits === 1 ? "credit" : "credits"}}</b>. Unfortunately you have insufficient funds.
          </p>
          <p>
            Please click the "Buy Credits" button below to get more credits so you can enter.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="dialogInsufficientFunds = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="fanhiveHoney"
            @click="buyCredits"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            Buy Credits
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNotLoggedIn"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Log In Required</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedCompetition" style="color:#ffffff;" class="honeyBold">
          <p>
            Please join and/or log in to Fanhive in order to enter Competitions.
          </p>
          <p>
            Use the buttons below to get started.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="dialogNotLoggedIn = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="fanhiveHoney"
            @click="goTo('join')"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            Join
          </v-btn>
          <v-btn
            outlined
            color="fanhiveHoney"
            @click="goTo('login')"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            Log in
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCompClosed"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Competition Closed</v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="selectedCompetition" style="color:#ffffff;" class="honeyBold">
          <p>
            Competitions close for new entries 5 minutes before the specified competition close time.
          </p>
          <p>
            Hit the Refresh button to see what competitions are open.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="compClosed"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="fanhiveHoney"
            text
            @click="compClosed"
          >
            Refresh
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Spinner :overlay="overlay"></Spinner>
    <form method="POST" ref="tpForm" action="https://payments.securetrading.net/process/payments/choice">
      <input type="hidden" name="sitereference" :value="tpSiteId">
      <input type="hidden" name="stprofile" value="default">
      <input type="hidden" name="stdefaultprofile" value="st_iframe_cardonly">
      <input type="hidden" name="ruleidentifier" value="STR-6">
      <input type="hidden" name="successfulurlredirect" :value="payReturnUrl">
      <input type="hidden" name="ruleidentifier" value="STR-7">
      <input type="hidden" name="declinedurlredirect" :value="payReturnUrl">
      <input type="hidden" name="ruleidentifier" value="STR-13">
      <input type="hidden" name="errorurlredirect" :value="payReturnUrl">
      <input type="hidden" name="currencyiso3a" value="GBP">
      <input type="hidden" name="mainamount" value="" ref="mainamount">
      <input type="hidden" name="version" value="2">
      <input type="hidden" name="stextraurlredirectfields" value="paymentRequestId">
      <input type="hidden" ref="customone" name="paymentRequestId">
      <input type="hidden" name="stextraurlredirectfields" value="competitionId">
      <input type="hidden" ref="customtwo" name="competitionId">
    </form>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import CompetitionTeam from './CompetitionTeam';
import _ from 'lodash';
import Socket from "./../../plugins/socket";
import moment from "moment";
import Spinner from './../../components/Spinner';

export default {
  name: 'activecompetitions',
  components: {
    PageHeader,
    CompetitionTeam,
    Spinner
  },
  data: () => ({ 
    competitions: null,
    dialog: false,
    dialogInsufficientFunds: false,
    dialogNotLoggedIn: false,
    dialogCompClosed: false,
    selectedCompetition: null,
    overlay: false,
    walletUpdateCount: 0,
    entryId: null,
    paymentRequestId: null
  }),
  computed: {
    wallet () {
      if(!this.$store.getters.wallet){
        return {
          balance: 0,
          honeyPointsBalance: 0
        };
      }
      return this.$store.getters.wallet;
    },
    updatingWalletCredits () {
      return this.$store.getters.updatingWalletCredits;
    },
    updatingWalletHoneyPoints () {
      return this.$store.getters.updatingWalletHoneyPoints;
    },
    creatingEntry () {
      return this.$store.getters.creatingEntry;
    },
    creatingPaymentRequest () {
      return this.$store.getters.creatingPaymentRequest;
    },
    selectedCupId () {
      return this.$store.getters.selectedCupId;
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
    payReturnUrl () {
      return this.$store.getters.payReturnUrl;
    },
    tpSiteId () {
      return this.$store.getters.tpSiteId;
    }
  },
  methods: {
    refresh: function () {
      this.getCompetitions('all');
    },
    getCompetitions: function (cupId) {
      let scope = this;
      var sortFilter = "sortBy=end_date&sortByDirection=asc"
      if(cupId !== 'all'){
        sortFilter = sortFilter + '&match_cup_id=' + cupId
      }
      var filter = "?active=true&" + sortFilter;

      scope.overlay = true;
      this.$store.dispatch('getCompetitions', filter).then(response => {
        scope.competitions = response;

        if(scope.$route.query.competitionId !== undefined){
          this.selectedCompetition = _.find(this.competitions, (o) => {
            return o.id === scope.$route.query.competitionId;
          });
          scope.agreeAndStart();
        } else {
          scope.overlay = false;
        }

        
        }, error => {
            console.log(error);
        });
    },
    enterFor: function (competitionId) {

      if(this.$store.getters.connectionId === null){
        console.log('Connectionid is null when entering for, must get new one.');
        if(this.isLoggedIn)
        Socket.connect(this.$store.getters.userSub.userName);
      }

      this.selectedCompetition = _.find(this.competitions, (o) => {
        return o.id === competitionId;
      });

      var secondsTillEnd = moment(this.selectedCompetition.endDate).unix() - moment().unix();
      
      if(this.isLoggedIn) {
        if(secondsTillEnd >= 300){
          this.dialog=true;
        } else {
          this.dialogCompClosed=true;  
        }
      } else {
        this.dialogNotLoggedIn=true;
      }
    },
    buyCredits: function () {
      this.dialogInsufficientFunds = false;
      this.$router.push({name: 'buy-credits'});
    },
    reconnect: function (from) {
      var scope = this;
      console.log('Connectionid is null when agreeing and starting, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        switch(from){
          case 'buy-entry':{
            scope.buyEntry();
            break;
          }
          default: {
            scope.agreeAndStart();
          }
        }
      }, 2500);
    },
    buyEntry: function () {

      this.dialog = false;
      this.overlay = true;
      var scope = this;
      if(scope.$store.getters.connectionId === null){
        scope.reconnect('buy-entry');
        return;
      }
      
      scope.$store.commit('setCreatingPaymentRequest', 1);
      scope.$store.dispatch('addPaymentRequest', {
        userId: scope.$store.getters.userSub.id,
        competitionId: scope.selectedCompetition.id,
        amount: scope.selectedCompetition.entryCredits
      }).then(addPaymentRequestResponse => {
        console.log(`New Payment Request added [${addPaymentRequestResponse.id}]`);
        scope.paymentRequestId = addPaymentRequestResponse.id;
      }, error => {
          console.log(error);
      });
      //this.$router.push({name: 'buy-entry', query: {ticketCount: 1, totalCost: this.selectedCompetition.entryCredits, competitionId: this.selectedCompetition.id}});
    },
    agreeAndStart: function () {
      this.dialog = false;
      this.overlay = true;
      var scope = this;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      this.walletUpdateCount = 0;
      this.entryId = null;
      scope.$store.commit('setUpdatingWalletCredits', 1);
      this.$store.dispatch('addWalletTransaction', {
      walletId: scope.$store.getters.wallet.id,
      isDebit: true,
      amount: scope.selectedCompetition.entryCredits,
      notes: 'Entry'
    }).then(addWalletTransactionResponse => {
          console.log(`New wallet transaction added [${addWalletTransactionResponse.id}]`);

          scope.$store.commit('setCreatingEntry', 1);
          scope.$store.dispatch('addEntry', {
            userId: scope.$store.getters.userSub.id,
            competitionId: scope.selectedCompetition.id,
            entryCredits: scope.selectedCompetition.entryCredits
          }).then(addEntryResponse => {
            console.log(`New entry added [${addEntryResponse.id}]`);
            scope.entryId = addEntryResponse.id;
            
            scope.$store.commit('setUpdatingWalletHoneyPoints', 1);
            scope.$store.dispatch('addHoneyTransaction', {
                userId: scope.$store.getters.userSub.id,
                walletId: scope.$store.getters.wallet.id,
                entryId: addEntryResponse.id,
                isDebit: false,
                honeyPointSlug: 'entry'
              }).then(addHoneyTransactionResponse => {
                  console.log(`New honey transaction added [${addHoneyTransactionResponse.id}]`);
                }, error => {
                    console.log(error);
                });
            }, error => {
                console.log(error);
            });
          
        }, error => {
            console.log(error);
        });
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingWalletCredits', 0);
          scope.$store.commit('setUpdatingWalletHoneyPoints', 0);
          scope.$store.commit('setCreatingEntry', 0);
          scope.overlay = false;
          scope.$router.push({name: 'questions', query: { 
            entryId: scope.entryId,
            sportId: scope.selectedCompetition.sportId,
            totalQuestions: scope.selectedCompetition.totalQuestions
          }});
        }, error => {
            console.log(error);
        })
    },
    goTo: function (name) {
      this.dialogNotLoggedIn=false;
      this.$router.push({name: name});
    },
    compClosed: function () {
      this.getCompetitions('all');
      this.dialogCompClosed = false;
    }
  },
  created () {
    this.$store.commit('setShowSlideMenu', 'compfilters');
    this.getCompetitions('all');
  },
  watch: {
      updatingWalletCredits (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      updatingWalletHoneyPoints (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      creatingEntry (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      creatingPaymentRequest (newVal) {
        if(newVal === 2){
          this.$refs.customone.value = this.paymentRequestId;
          this.$refs.mainamount.value = this.selectedCompetition.entryCredits;
          this.$refs.customtwo.value = this.selectedCompetition.id;
          this.$refs.tpForm.submit();
        }
          
      },
      walletUpdateCount (newVal) {
        console.log(newVal);
        if(newVal === 3) {
          this.updateWallet();
        }
      },
      selectedCupId (newVal) {
        console.log('Cup changed: ' + newVal);
        this.getCompetitions(newVal);
      }
    }
};
</script>
